import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from '../layout/pagination/pagination.module';
import { DiscountCreateComponent } from './modals/create/create.component';
import { DiscountDeleteComponent } from './modals/delete/delete.component';
import { DiscountEditComponent } from './modals/edit/edit.component';
import { DiscountsComponent } from './discounts.component';

@NgModule({
  imports: [
    CommonModule,
    PaginationModule,
    FormsModule,
    DiscountsComponent,
    DiscountDeleteComponent,
    DiscountCreateComponent,
    DiscountEditComponent,
  ],
  exports: [DiscountsComponent],
})
export class DiscountsModule {}
